// libs
import { memo } from "react";
import styled from "@emotion/styled";

const Error = styled.div`
    color: #ff0000;
    line-height: 1.5;
    font-size: 1rem;
`;

export default memo(Error);
